import { Component, OnInit, OnDestroy, ViewChild, Input } from '@angular/core';
import { AccountService } from '../services/account/account.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { serviceWorkflow } from '../models/service';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CompileShallowModuleMetadata } from '@angular/compiler';
import { PaymentConfig } from '../models/paymentConfig';
import { PaymentService } from '../services/payment/payment.service';
import { LoginComponent } from '../login/login.component';

declare var $: any;
@Component({
  selector: 'app-payment-subscription',
  templateUrl: './payment-subscription.component.html',
  styleUrls: ['./payment-subscription.component.css']
})

export class PaymentSubscriptionComponent implements OnInit, OnDestroy {
  //@ViewChild(LoginComponent) login : LoginComponent;

  accounts: any[];
  foruscareService: ForuscareService;
  serviceWorkFlow: any[] = [];
  accountId = 0;
  prepaidStatus = false;
  postpaidStatus = false;
  paymentConfig: PaymentConfig;
  loginUserId;
  showRefractionModule;
  showReferralModule;
  showFundusModule;
  showSpectacleModule;

  refraction_objectiveWithAutoRef = 0
  refraction_subjective = 0
  refraction_prescription = 0

  teleRefraction_refraction = 0
  teleRefraction_avCallWithOptometrist = 0

  fundusExamination_fundusImaging = 0
  fundusExamination_aiAssist_AIForGrading = 0
  fundusExamination_aiAssist_AIForDiagnosis = 0
  fundusExamination_expertReportGenerationWithSLA = 0
  fundusExamination_expertReportGenerationWithoutSLA = 0
  fundusExamination_rejectedFundus = 0
  fundusExamination_qaFailedCases = 0


  fundusExaminationAutonomous_fundusImaging = 0
  fundusExaminationAutonomous_aiAutonomousResult = 0


  referral_tetiaryHospitalReferral_TBD = 0
  referral_referralReportGeneration = 0
  referral_referralFollowUpwithExternal = 0

  spectacle_ecartAndInventoryManagement = 0
  spectacle_spectaclewithSLA = 0
  spectacle_spectacleWithoutSLA = 0
  spectacle_spectacleOrderStatusUpdate = 0
  spectacle_replacementUnderWarranty = 0
  spectacle_repairAfterReplacement = 0

  spectacle_basicWorkflow = 0
  spectacle_orderWorkflow = 0
  spectacle_3dHeadMeasurement = 0
  resetWorkFlowObject() {
    this.workFlows = [
      { serviceId: 1, serviceName: "MEDICAL_INFO", draggable: false, serviceOrder: 0, status: true, isMandatory: false },
      { serviceId: 2, serviceName: "REFRACTION", draggable: true, serviceOrder: 1, status: true, isMandatory: false },
      { serviceId: 3, serviceName: "SPECTACLE", draggable: true, serviceOrder: 2, status: true, isMandatory: false },
      { serviceId: 4, serviceName: "FUNDUS", draggable: true, serviceOrder: 3, status: true, isMandatory: false },
      { serviceId: 5, serviceName: "REFERRAL", draggable: false, serviceOrder: 4, status: true, isMandatory: false }
    ];
  }
  constructor(public accountService: AccountService, public paymentService: PaymentService) {
    this.foruscareService = new ForuscareService();
    this.paymentConfig = new PaymentConfig();
  }

  workFlows = [
    { serviceId: 1, serviceName: "MEDICAL_INFO", draggable: false, serviceOrder: 0, status: true, isMandatory: false },
    { serviceId: 2, serviceName: "REFRACTION", draggable: true, serviceOrder: 1, status: true, isMandatory: false },
    { serviceId: 3, serviceName: "SPECTACLE", draggable: true, serviceOrder: 2, status: true, isMandatory: false },
    { serviceId: 4, serviceName: "FUNDUS", draggable: true, serviceOrder: 3, status: true, isMandatory: false },
    { serviceId: 5, serviceName: "REFERRAL", draggable: false, serviceOrder: 4, status: true, isMandatory: false }
  ];


  ngOnInit() {
    this.getAvailableAccounts();
    $('#content-wrapper').removeClass('content-wrapper')
  }
  ngOnDestroy() {
  }



  getServiceWorkFlowByAccountId() {
    this.serviceWorkFlow = [];
    if (this.accountId == null || this.accountId == 0) {
      return;
    }
    this.accountService.getAccountWorkflowByAccountId(this.accountId)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null && response.data.length > 0) {
            response.data.forEach(data => {
              if (data.serviceName == "REFRACTION" && data.status == true) {
                //data.draggable = false;
                this.showRefractionModule = true;
              }
              if (data.serviceName == "REFERRAL" && data.status == true) {
                //data.draggable = false;
                this.showReferralModule = true;
              }
              if (data.serviceName == "FUNDUS" && data.status == true) {
                //data.draggable = false;
                this.showFundusModule = true;
              }
              if (data.serviceName == "SPECTACLE" && data.status == true) {
                //data.draggable = false;
                this.showSpectacleModule = true;
              }

              else {
                data.draggable = true;
              }
            });
            this.serviceWorkFlow = response.data;
          }
          else {
            this.resetWorkFlowObject();
            this.serviceWorkFlow = this.workFlows;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  getAvailableAccounts() {
    this.accounts = [];
    this.accountService.getExistingAccounts()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            if (response.data.length > 0) {
              response.data.unshift({
                accountName: 'Select Account',
                accountId: 0
              });
            }
            this.accounts = response.data;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  showStatus(type) {
    if (type == 'postpaid') {
      this.prepaidStatus = !this.postpaidStatus;
    }
    if (type == 'prepaid') {
      this.postpaidStatus = !this.prepaidStatus;
    }

  }

  savePaymentConfig() {
    //if((this.paymentConfig.refraction==null && this.showRefractionModule==true) || (this.paymentConfig.teleRefraction==null && this.showRefractionModule==true) || (this.paymentConfig.fundus==null && this.showFundusModule==true)|| (this.paymentConfig.fundusAutonomous==null && this.showFundusModule==true)|| (this.paymentConfig.referral==null && this.showReferralModule==true)|| (this.paymentConfig.spectacleBasic==null && this.showSpectacleModule==true) || (this.paymentConfig.spectacleAdvanced==null && this.showSpectacleModule==true)){
    // if ((this.paymentConfig.refraction == null && this.showRefractionModule == true) || (this.paymentConfig.teleRefraction == null && this.showRefractionModule == true) || (this.paymentConfig.fundus == null && this.showFundusModule == true) || (this.paymentConfig.referral == null && this.showReferralModule == true)) {
    //   this.foruscareService.showNotification("Enter all the mandatory fields", "danger");
    //   return;
    // }
    this.paymentConfig.accountId = this.accountId.toString();
    this.paymentConfig.status = true;
    //this.paymentConfig.createdBy=98;
    if (this.paymentConfig.id == null) {
      this.paymentService.savePaymentConfig(this.paymentConfig)
        .subscribe(response => {
          if (response.errorCode == 200) {
            this.foruscareService.showNotification("Saved Successfully !", "success");
          }
          else {
            this.foruscareService.showNotification("Something went wrong", "danger");
          }
        })
    }
    if (this.paymentConfig.id != null) {
      this.paymentService.updatePaymentConfig(this.paymentConfig)
        .subscribe(response => {
          if (response.errorCode == 200) {
            this.foruscareService.showNotification("Updated Successfully !", "success");
          }
          else {
            this.foruscareService.showNotification("Something went wrong", "danger");
          }
        })
    } 
  }

  getPaymentConfig() {
    if (this.accountId !== null) {
      this.paymentService.getPaymentConfig(this.accountId)
        .subscribe(response => {
          if (response.errorCode == 200) {
            if (response.data != null) {
              this.paymentConfig.fundus = response.data.fundus;
              this.paymentConfig.fundusAutonomous = response.data.fundusAutonomous;
              this.paymentConfig.referral = response.data.referral;
              this.paymentConfig.teleRefraction = response.data.teleRefraction;
              this.paymentConfig.refraction = response.data.refraction;
              this.paymentConfig.spectacleBasic = response.data.spectacleBasic;
              this.paymentConfig.spectacleAdvanced = response.data.spectacleAdvanced;
              this.paymentConfig.id = response.data.id;
            }
            if (response.data == null) {
              this.paymentConfig.fundus = null;
              this.paymentConfig.fundusAutonomous = null;
              this.paymentConfig.referral = null;
              this.paymentConfig.teleRefraction = null;
              this.paymentConfig.refraction = null;
              this.paymentConfig.spectacleBasic = null;
              this.paymentConfig.spectacleAdvanced = null;
            }
            // this.foruscareService.showNotification("Payment Config Details Loaded!", "success");
          }
          else {
            this.foruscareService.showNotification("Something went wrong", "danger");
          }
        })
    }
  }

  changeAccountSubscriptionType() {
    var subscriptionType;
    if (this.prepaidStatus == true) {
      subscriptionType = "POSTPAID";
    }
    if (this.prepaidStatus == false) {
      subscriptionType = "PREPAID";
    }

    this.paymentService.changeAccountSubscriptionType(this.accountId, subscriptionType)
      .subscribe(response => {
        if (response.errorCode == 200) {
          this.foruscareService.showNotification("Subscription type updated", "success");
        }
        else {
          this.foruscareService.showNotification("Something went wrong", "danger");
        }
      })
  }

  getSubscriptionType(selectedAccountId) {
    if (selectedAccountId != 0) {
      for (var i = 0; i < this.accounts.length; i++) {
        if (this.accounts[i].id == selectedAccountId) {
          if (this.accounts[i].subscriptionType == 'PREPAID') {
            this.prepaidStatus = true;
          }
          if (this.accounts[i].subscriptionType == 'POSTPAID') {
            this.prepaidStatus = false;
          }
          return;
        }
      }
    }
  }
}
